import React from 'react'
import * as C from "../componentsM/index";

const Counselling = () => {
    return (

        <>

            <C.Hero title={"COUNSELLING (PERSONAL, ACADEMIC)"} image={"/hero/16.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <h1>Personal or academic Counselling service is provided to “at risk” students who are constantly “off the track”. Based on the informal or formal needs report on a student by the general staff and the school Psychologist respectively, the Special Education Needs (SEN) team prepares a programme to address the needs and alleviate all contextual or situational concerns creating impediments in the students’ academic and non-academic life at school.</h1>

                    <h1>For more detail please refer to the SEN Programme Guide.</h1>
                </div>





            </section>

        </>
    )
}

export default Counselling